import { render, staticRenderFns } from "./Auth_LegalDisclaimer.vue?vue&type=template&id=cf9341be&"
import script from "./Auth_LegalDisclaimer.vue?vue&type=script&lang=js&"
export * from "./Auth_LegalDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports